import { NgModule } from "@angular/core";
import { CommonModule } from "@angular/common";
import { FormsModule } from "@angular/forms";
import { RouterModule } from "@angular/router";
import { ReactiveFormsModule } from "@angular/forms";

import { NgbModule } from "@ng-bootstrap/ng-bootstrap";
import { FontAwesomeModule } from "@fortawesome/angular-fontawesome";

import { ShowIfUserCanDirective } from "./directive/show-if-user-can.directive";
import { EnableButtonIfUserCanDirective } from "./directive/enable-button-if-user-can.directive";
import { ShowIfUserCannotDirective } from "./directive/show-if-user-cannot.directive";

import { ContextCurrentComponent } from "./component/context-current/context-current.component";
import { ContextSelectorComponent } from "./component/context-selector/context-selector.component";
import { ChangePasswordModalComponent } from "./component/modals/change-password-modal/change-password-modal.component";
import { ChangeProfileModalComponent } from "./component/modals/change-profile-modal/change-profile-modal.component";
import { ErrorMessageComponent } from "./component/error-message/error-message.component";
import { LoadingIconComponent } from "./component/loading-icon/loading-icon.component";
import { DataGridComponent } from "./component/data-grid/data-grid.component";
import { DataGridCellComponent } from "./component/data-grid/cell/cell.component";
import { DataGridHeaderComponent } from "./component/data-grid/header/header.component";
import { TimeAgoPipe } from "./pipes/time-ago.pipe";
import { LabelComponent } from "./component/label/label/label.component";
import { LabelCollectionComponent } from "./component/label/collection/collection.component";
import { LabelListComponent } from "./component/label/list/list.component";
import { DataGridEmptyTableComponent } from "./component/data-grid/empty-table/empty-table.component";
import { ComparisonConditionComponent } from "./component/comparison-condition/comparison-condition.component";

@NgModule({
  declarations: [
    // Directives
    ShowIfUserCanDirective,
    ShowIfUserCannotDirective,
    EnableButtonIfUserCanDirective,

    // Components
    ContextCurrentComponent,
    ContextSelectorComponent,
    ChangePasswordModalComponent,
    ChangeProfileModalComponent,
    ComparisonConditionComponent,
    DataGridComponent,
    DataGridCellComponent,
    DataGridHeaderComponent,
    DataGridEmptyTableComponent,
    ErrorMessageComponent,
    LabelComponent,
    LabelCollectionComponent,
    LabelListComponent,
    LoadingIconComponent,

    // Pipes
    TimeAgoPipe,



  ],
  imports: [
    // Angular
    CommonModule,
    FormsModule,
    RouterModule,
    ReactiveFormsModule,

    // 3rd Party
    NgbModule,
    FontAwesomeModule,
  ],
  exports: [
    // Angular
    CommonModule,
    FormsModule,
    ReactiveFormsModule,

    // 3rd party
    NgbModule,
    FontAwesomeModule,

    // App
    ShowIfUserCanDirective,
    ShowIfUserCannotDirective,
    EnableButtonIfUserCanDirective,

    // Components
    ContextCurrentComponent,
    ContextSelectorComponent,
    ChangePasswordModalComponent,
    ChangeProfileModalComponent,
    ComparisonConditionComponent,
    DataGridComponent,
    ErrorMessageComponent,
    LabelComponent,
    LabelCollectionComponent,
    LabelListComponent,
    LoadingIconComponent,

    // Pipes
    TimeAgoPipe,
  ]
})
export class SharedModule { }
